var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":_vm.color,"prominent":"","text":"","icon":_vm.icon}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }